import React, {Component} from 'react';
import 'index.css';
import Context from 'utils/Context';

class Link extends Component {
  isModifiedEvent = event => {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
  };
  handleClick = event => {
    let url = event.currentTarget.pathname + event.currentTarget.search;
    let target = event.currentTarget.target;
    if (
      !event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      (!target || target === '_self') && // let browser handle "target=_blank" etc.
      !this.isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
      event.preventDefault();
      this.context.goTo(url);
    }
  };
  render() {
    let {url, children, className} = this.props;
    return (
      <a href={url} className={className} onClick={this.handleClick}>
        {children}
      </a>
    );
  }
}
Link.contextType = Context;
export default Link;
